import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export type StatPillTone = 'ok' | 'warn' | 'danger' | 'info' | 'neutral';

export interface StatPillProps {
  tone: StatPillTone;
  children: ReactNode;
  mono?: boolean;
  className?: string;
}

const TONE: Record<StatPillTone, { text: string; dot: string }> = {
  ok: { text: 'text-ok', dot: 'bg-okDot' },
  warn: { text: 'text-warn', dot: 'bg-warnDot' },
  danger: { text: 'text-danger', dot: 'bg-dangerDot' },
  info: { text: 'text-accent', dot: 'bg-accent' },
  neutral: { text: 'text-textMute', dot: 'bg-textSoft' },
};

export function StatPill({
  tone,
  children,
  mono = true,
  className,
}: StatPillProps) {
  const t = TONE[tone];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-[5px] text-[10.5px] font-bold tracking-[0.02em] leading-none',
        mono ? 'font-mono' : 'font-sans',
        t.text,
        className
      )}
    >
      <span
        className={cn(
          'inline-block w-[5px] h-[5px] rounded-full flex-shrink-0',
          t.dot
        )}
        data-testid="statpill-dot"
      />
      {children}
    </span>
  );
}

StatPill.displayName = 'StatPill';

export default StatPill;
